import { createSelector } from 'reselect';
import { SnackbarStore } from './models';

export const namespace = 'snackbar';

export const selectStore = (store: { [namespace]: SnackbarStore }) =>
  store[namespace];

export const selectSnackbars = createSelector(
  selectStore,
  (s) => s.notifications
);
